import React from 'react';

import RoleLayout from './RoleLayout';
import { createUserHeaderMenuConfig } from '../../Components/HeaderMenu/menuConfig';

export default function UserLayout(props) {
    return (
        <RoleLayout
            {...props}
            scope="user"
            fallbackPath="/console"
            menuConfig={({ adminPrivileges }) => createUserHeaderMenuConfig({ adminPrivileges })}
        />
    );
}



// WEBPACK FOOTER //
// ./src/hoc/Layout/UserLayout.js